export default function getFormElementState(errorMessage) {
  return !!errorMessage ? "error" : "default";
}
